import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingGroupBy;

const dataProcessingGroupByData = createSelector([selector], (state) => state);

export default {
  dataProcessingGroupByData
};
